// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 515) return "static/chunks/515-d0c1dc826116f92a.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + "5d618db031c02822" + ".js";
};